import Select from '@/elements/Select'
import Box from '@/primitives/Box'
import Text from '@/primitives/Text'

export function FilterSelect({
  options,
  onChange,
  name,
  value,
  isDisabled = false,
  label
}) {
  return (
    <Box>
      {label && (
        <Text variant='page' tone={600}>
          {' '}
          {label}{' '}
        </Text>
      )}
      <Select
        options={options}
        onChange={onChange}
        name={name}
        value={value}
        isDisabled={isDisabled}
      />
    </Box>
  )
}
